export default __webpack_public_path__ + "static/media/print.5ad8daa2.svg";